"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jarFilesToScannedProjects = void 0;
const admzip = require("adm-zip");
const path = require("path");
const buffer_utils_1 = require("../../buffer-utils");
function groupJarFingerprintsByPath(input) {
    const jarFingerprints = Object.entries(input).map(([filePath, digest]) => {
        return {
            location: filePath,
            digest,
        };
    });
    const resultAggregatedByPath = jarFingerprints.reduce((jarsAggregatedByPath, jarFingerprint) => {
        const location = path.dirname(jarFingerprint.location);
        jarsAggregatedByPath[location] = jarsAggregatedByPath[location] || [];
        jarsAggregatedByPath[location].push(jarFingerprint);
        return jarsAggregatedByPath;
    }, {});
    return resultAggregatedByPath;
}
async function jarFilesToScannedProjects(filePathToContent, targetImage, desiredLevelsOfUnpacking) {
    const mappedResult = groupJarFingerprintsByPath(filePathToContent);
    const scanResults = [];
    for (const path in mappedResult) {
        if (!mappedResult.hasOwnProperty(path)) {
            continue;
        }
        const fingerprints = getFingerprints(desiredLevelsOfUnpacking, mappedResult[path]);
        const jarFingerprintsFact = {
            type: "jarFingerprints",
            data: {
                fingerprints,
                origin: targetImage,
                path,
            },
        };
        scanResults.push({
            facts: [jarFingerprintsFact],
            identity: {
                type: "maven",
                targetFile: path,
            },
        });
    }
    return scanResults;
}
exports.jarFilesToScannedProjects = jarFilesToScannedProjects;
function getFingerprints(desiredLevelsOfUnpacking, jarBuffers) {
    if (desiredLevelsOfUnpacking === 0) {
        return getJarShas(jarBuffers);
    }
    return unpackFatJars(jarBuffers, desiredLevelsOfUnpacking);
}
function getJarShas(jarBuffers) {
    return jarBuffers.map((element) => {
        return Object.assign(Object.assign({}, element), { digest: buffer_utils_1.bufferToSha1(element.digest) });
    });
}
function unpackJarsTraverse({ jarBuffer, jarPath, desiredLevelsOfUnpacking, unpackedLevels, jarBuffers, }) {
    let isFatJar = false;
    if (unpackedLevels >= desiredLevelsOfUnpacking) {
        jarBuffers.push({
            location: jarPath,
            digest: jarBuffer,
        });
    }
    else {
        const zip = new admzip(jarBuffer);
        const zipEntries = zip.getEntries();
        // technically the level should be increased only if a JAR is found, but increasing here to make
        // sure it states the level, and not counting all the jars found, regardless of level.
        unpackedLevels = unpackedLevels + 1;
        for (const zipEntry of zipEntries) {
            if (zipEntry.entryName.endsWith(".jar")) {
                isFatJar = true;
                const entryData = zipEntry.getData();
                const entryName = zipEntry.entryName;
                jarPath = `${jarPath}/${entryName}`;
                unpackJarsTraverse({
                    jarBuffer: entryData,
                    jarPath,
                    desiredLevelsOfUnpacking,
                    unpackedLevels,
                    jarBuffers,
                });
            }
        }
        if (!isFatJar) {
            jarBuffers.push({
                location: jarPath,
                digest: jarBuffer,
            });
        }
    }
    return jarBuffers;
}
function unpackFatJars(jarBuffers, desiredLevelsOfUnpacking) {
    const fingerprints = [];
    for (const jarBuffer of jarBuffers) {
        const unpackedLevels = 0;
        const jars = unpackJarsTraverse({
            jarBuffer: jarBuffer.digest,
            jarPath: jarBuffer.location,
            desiredLevelsOfUnpacking,
            unpackedLevels,
            jarBuffers: [],
        });
        fingerprints.push(...getJarShas(jars));
    }
    return fingerprints;
}
//# sourceMappingURL=java.js.map